export const ibanRegexp =
  /^([A-Z]{2}[ \\-]?[0-9]{2})(?=(?:[ \\-]?[A-Z0-9]){9,30}$)((?:[ \\-]?[A-Z0-9]{3,5}){2,7})([ \\-]?[A-Z0-9]{1,3})?$/;

export const swiftRegexp = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const sortCodeRegexp = /^(\d){2}-(\d){2}-(\d){2}$/;
